(function () {
  function stripHtml(text) {
    return String(text || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function setHtml(pref, html) {
    if (pref && Object.prototype.hasOwnProperty.call(pref, 'content')) pref.content = html;
  }

  function patchChoiceLabel(quiz, from, to) {
    quiz.questions.forEach(function (question) {
      (question.blocks || []).forEach(function (block) {
        var choices = block.preferences && block.preferences.choices;
        if (!choices) return;
        choices.forEach(function (choice) {
          if (choice.label === from) choice.label = to;
        });
      });
    });
  }

  function productGid(id) {
    return 'gid://shopify/Product/' + id;
  }

  function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function firstBlock(section, type) {
    return (section.blocks || []).find(function (block) { return block.type === type; });
  }

  function patchResultSection(section, heading, text, productIds) {
    var headingBlock = firstBlock(section, 'heading');
    var textBlock = firstBlock(section, 'text');
    if (headingBlock && headingBlock.preferences) {
      headingBlock.preferences.content = '<p>' + heading + '</p>';
    }
    if (textBlock && textBlock.preferences) {
      textBlock.preferences.content = '<p>' + text + '</p>';
    }
    (section.blocks || []).forEach(function (block) {
      if (block.type !== 'slots' || !block.preferences) return;
      (block.preferences.slots || []).forEach(function (slot) {
        slot.includedProductsIds = productIds.map(productGid);
      });
    });
  }

  function patchQuiz() {
    var quiz = window.quizzes && window.quizzes.quiz_y0gGQN;
    if (!quiz || window.__esQuizY0gGQNFixed) return Boolean(quiz);
    window.__esQuizY0gGQNFixed = true;

    quiz.preferences = quiz.preferences || {};
    quiz.preferences.language = 'fr';
    quiz.preferences.setUTMSource = true;

    quiz.content = quiz.content || {};
    var labels = {
      ada_answer_before_proceeding: 'Réponds avant de continuer',
      ada_next_question: 'Question suivante',
      ada_no_previous_question: 'Aucune question précédente',
      ada_previous_question: 'Question précédente',
      ada_quiz_complete: 'Quiz terminé',
      add_to_cart: 'Ajouter au panier',
      next: 'Suivant',
      loading_error_no_response: 'Un problème est survenu lors de l’enregistrement de tes réponses. Actualise le quiz ou réessaie plus tard.',
      loading_error_retry: 'Nous réessayons d’enregistrer tes réponses…',
      sold_out: 'Indisponible',
      subscription_one_time_purchase: 'Achat unique',
      subscription_subscribe_and_save: 'S’abonner et économiser',
      try_again: 'Réessayer',
      view_product: 'Voir le produit'
    };
    Object.keys(labels).forEach(function (key) {
      if (quiz.content[key]) quiz.content[key].value = labels[key];
    });

    patchChoiceLabel(quiz, 'Purifier mon organisme / détox', 'Retrouver une sensation de légèreté');
    patchChoiceLabel(quiz, 'Lourdeur, digestion lente ou ballonnements', 'Sensation de lourdeur après les repas');
    patchChoiceLabel(quiz, 'Besoin d’un nettoyage intérieur', 'Envie d’une routine plus légère');
    patchChoiceLabel(quiz, 'J’ai la peau terne, j’aimerais un effet beauté.', 'J’aimerais raviver l’éclat de ma peau.');
    patchChoiceLabel(quiz, 'J’ai des imperfections.', 'J’aimerais prendre soin de l’éclat de ma peau.');

    (quiz.questions || []).forEach(function (question) {
      (question.blocks || []).forEach(function (block) {
        var pref = block.preferences || {};
        var text = stripHtml(pref.content || '');
        if (block.type === 'button' && (pref.content === 'Next' || pref.content === 'next')) pref.content = 'Suivant';
        if (text === 'Q10 – Recevoir nos informations régulièrement et les résultats de mon test.') {
          pref.content = '<p>Q10 – Recevoir mon résultat par e-mail ?</p>';
        }
        if (block.type === 'input' && pref.type === 'email') {
          pref.optional = true;
          pref.inputPlaceholder = 'Ton email (facultatif)';
          pref.errorMessage = 'Adresse email invalide';
          pref.shopifyConsentState = 'NOT_SUBSCRIBED';
          pref.shopifyOptInLevel = 'SINGLE_OPT_IN';
        }
        if (block.type === 'text' && stripHtml(pref.content).indexOf('J’accepte de recevoir les e-mails Ellesensitive') === 0) {
          pref.content = '<p>Si tu laisses ton email, il sert à recevoir ton résultat et les conseils Ellesensitive. Tu pourras te désinscrire à tout moment. Aucun achat ni abonnement n’est nécessaire.</p>';
        }
      });
    });

    var result = (quiz.results || [])[0];
    if (result) {
      result.preferences = result.preferences || {};
      result.preferences.discountCode = '';
      var sections = result.sections || [];
      sections.forEach(function (section) {
        var logic = JSON.stringify(section.logic || {});
        if (logic.indexOf('BeauThé') !== -1) {
          patchResultSection(section, 'Notre rituel BeauThé est fait pour toi', 'Une routine beauté à boire pour accompagner ton éclat et transformer ta pause thé en moment pour toi.', ['9485304267089']);
        } else if (logic.indexOf('DigesThé') !== -1) {
          patchResultSection(section, 'Ton rituel confort après-repas', 'DigesThé accompagne une routine bien-être de 21 jours, avec 4 assemblages bio pensés pour une sensation de légèreté après les repas.', ['9421454836049']);
        } else if (logic.indexOf('DécontracThé') !== -1) {
          patchResultSection(section, 'Ton rituel sérénité', 'DécontracThé t’aide à installer une pause plus calme et réconfortante dans ta journée, sans promesse miracle.', ['9421454377297']);
        } else if (logic.indexOf('IntensiThé') !== -1) {
          patchResultSection(section, 'Ton rituel boost ciblé', 'IntensiThé est la piste la plus adaptée si tu cherches une routine plus dynamique et concentrée.', ['9421454704977']);
        } else if (logic.indexOf('PureThé') !== -1) {
          patchResultSection(section, 'Ton rituel fraîcheur et légèreté', 'PureThé accompagne une routine bien-être plus fraîche et légère, sans discours détox agressif.', ['9421454541137']);
        } else if (logic.indexOf('VitaliThé') !== -1) {
          patchResultSection(section, 'Ton rituel énergie du quotidien', 'VitaliThé est la piste la plus adaptée si tu veux soutenir ton tonus et garder une routine simple à suivre.', ['9421454049617']);
        }
      });

      var hasDream = sections.some(function (section) {
        return JSON.stringify(section.logic || {}).indexOf('DreamThé') !== -1;
      });
      var source = sections.find(function (section) {
        return JSON.stringify(section.logic || {}).indexOf('DécontracThé') !== -1;
      }) || sections[0];
      if (!hasDream && source) {
        var dream = clone(source);
        dream.ref = 'rs-dreamthe-hermes-fix';
        dream.logic = {
          defaultShow: false,
          showLogic: [{ conditions: [{ operator: 'is', ref: 'cd-dreamthe-hermes-fix', sourceType: 'highestVariable', value: 'DreamThé' }] }]
        };
        patchResultSection(dream, 'Ton rituel nuit apaisée', 'DreamThé est la piste la plus adaptée si ton besoin principal est une pause du soir plus douce et un rituel de coucher apaisant.', ['9421454213457']);
        sections.push(dream);
      }
    }
    window.dispatchEvent(new CustomEvent('es:quiz-y0gGQN-fixed'));
    return true;
  }

  if (!patchQuiz()) {
    document.addEventListener('DOMContentLoaded', patchQuiz, { once: true });
    setTimeout(patchQuiz, 0);
  }
})();
